import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('cms-popup-management-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider.state('cms-loginPopupManagement', {
      parent: 'arw',
      url: '/cms-login-popup-management/',
      template: '<cms-login-popup-management></cms-login-popup-management>',
      redirectTo: 'permissions-denied',
      params: {
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Manage Login Notification')));
          },
        ],
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/login-popups/cms-popup-management-routing-module.js